import type * as C from "@zooi/contracts";
import { PROFILE_FACTS } from "@zooi/domain";

type Playbook = C.PlaybookLibrary["playbooks"][number];

/**
 * Group the playbooks a fact decision can unlock by everything they still need.
 * One that does not suit the product is no promise, nor is one that needs a
 * repository for an account, which has none to connect (2026-11-03).
 */
export function factUnlocks(playbooks: readonly Playbook[], factKey?: string, account = false) {
  const groups = new Map<string, { facts: string[]; repository: boolean; playbooks: Playbook[] }>();
  for (const playbook of playbooks) {
    if (!playbook.readiness || playbook.readiness.ready || playbook.fits_product === false) continue;
    // A private repository is not something a fact decision unlocks (2026-11-01).
    if (playbook.readiness.missing.some((gap) => gap.code === "repository_private")) continue;
    const facts = [...new Set(playbook.readiness.missing.flatMap((gap) => gap.code === "fact_unconfirmed" && gap.key ? [gap.key] : []))]
      .sort((a, b) => PROFILE_FACTS.indexOf(a as typeof PROFILE_FACTS[number]) - PROFILE_FACTS.indexOf(b as typeof PROFILE_FACTS[number]));
    if (!facts.length || (factKey && !facts.includes(factKey))) continue;
    const repository = playbook.readiness.missing.some((gap) => gap.code === "repository_missing");
    if (account && repository) continue;
    const key = JSON.stringify([facts, repository]);
    const group = groups.get(key) ?? { facts, repository, playbooks: [] };
    group.playbooks.push(playbook);
    groups.set(key, group);
  }
  return [...groups.values()];
}
